import moment from 'moment'

export default function(date) {
    return date ? moment(date).format('YYYY/MM/DD HH:mm') : ''
}

